import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Llegás a la sesión sin saber exactamente qué serie prescribir para el cuadro que tenés enfrente', 'Improvisás movimientos porque no tenés un protocolo clínico que te respalde', 'No sabés cómo estructurar la sesión completa — apertura, trabajo y cierre', 'Absorbés la energía densa de tus pacientes porque no tenés un protocolo de blindaje real', 'Sin protocolo de higiene energética del espacio entre sesiones', 'Sin series adaptadas por patología — armás cada sesión desde cero', 'Sin ficha clínica profesional — cada consulta sin registro ni continuidad', 'Sin planificación anual — trabajás semana a semana sin visión estratégica', 'Pacientes que no vuelven porque no perciben resultados concretos', 'Cada sesión la empezás de cero — sin estructura real ni respaldo clínico'];
  return <Section className="max-w-4xl" data-id="element-257">
      <div className="text-center mb-12" data-id="element-258">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-purpleDark" data-id="element-259">
          ¿Cuántas sesiones más vas a improvisar sin un sistema clínico sólido?
        </h2>
        <p className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-260">
          Sos terapeuta de Chi Kung. Amás lo que hacés. Creés en el poder
          transformador del Qi y el movimiento consciente. Pero hay una verdad
          que nadie te dijo cuando empezaste:
        </p>
        <p className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto font-bold" data-id="element-261">
          Saber Chi Kung no es lo mismo que tener un sistema clínico para
          aplicarlo con autoridad profesional.
        </p>
        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-262">
          Y esa diferencia la sentís cada vez que entrás al consultorio.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-purple/20" data-id="element-263">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-purpleDark text-base md:text-lg" data-id="element-264">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-265" /> Lo que
          pasa SIN el Mega Pack Chi Kung:
        </h3>
        <ul className="space-y-4" data-id="element-266">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-267">
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-268" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-269">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-270">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-271">
          ¿Y si esta fuera la última sesión que trabajás así?
        </h3>
      </div>
    </Section>;
};